export default {
  views: {
    product: {
      description:
        '東京スカイツリー展望台入場券と東京ソラマチに併設されるすみだ水族館の入場券がセットとなったお得なチケットです。',
      plans: {
        title: 'プランを選択'
      },
      cancelPolicy: {
        title: 'キャンセルポリシー'
      },
      panels: {
        selectDate: '日付を選択',
        selectPlan: 'プランを選択',
        selectPeople: '人数を選択',
        options: 'オプション',
        profile: 'プロフィール'
      },
      auth: {
        loginOrRegister: 'ログイン / 新規登録',
        signUpTip: '情報を入力して新規登録'
      },
      calendar: {
        priceNote: '※表示価格は大人料金'
      },
      recommendations: {
        title: '他のおすすめ'
      }
    },
    book: {
      title: '予約確認',
      bookingNotice: 'ご予約前にご確認ください',
      paymentConfirmation: 'お支払い前にご確認ください',
      tip: 'ご注文を確定するには、お早めに支払いを完了してください。'
    },
    bookConfirm: {
      paymentInfo: '支払い情報',
      paymentConfirmation: {
        warningTitle: 'キャンセルポリシーを確認してください：',
        warningText: '一度購入した商品は返金できません。',
        agreementText: '内容を確認し、同意しました'
      },
      prePaymentConfirmation: {
        title: 'お支払前の確認事項',
        checkInput: '入力内容に間違いないかご確認ください。',
        emailNotice:
          'ご注意：迷惑メール対策でドメイン指定受信設定をされている場合は、予約前に「@linktivity.co.jp」ドメインの登録をお願いします。',
        agreementText: '上記事項を確認の上、同意しました'
      },
      paymentAmount: {
        total: '支払い金額（税込）',
        details: '詳細',
        note: 'JPY以外の通貨で表示される金額は現在の為替レートに基づく推定値であり、実際の請求額とわずかに異なる場合があります。参考までにご確認ください。'
      },
      participantInfo: {
        title: '代表者情報',
        dialogTitle: '代表者情報を変更',
        change: '変更',
        password: 'パスワード',
        validation: {
          passwordRequired: 'パスワードを入力してください'
        }
      },
      actionButtons: {
        back: '前へ',
        toPayment: '支払いへ'
      }
    },
    voucher: {
      pdf: '印刷用PDF',
      html: 'バウチャーを表示'
    },
    bookingDetail: {
      title: '予約情報',
      detailInfo: '予約詳細',
      startDate: '参加日時',
      validityPeriod: '有効期限',
      voucherInfo: 'バウチャー情報',
      digitalTicket: '電子チケット',
      invoice: 'レシート・領収書',
      invoiceSend: '発行',
      invoiceSent: '領収書発行済み',
      redemption: 'Eチケットを利用',
      meetingPoint: '入場場所のご案内',
      beforeTrip: 'ご利用前の確認事項',
      bookingAction: '予約操作',
      cancelBooking: '注文をキャンセル',
      cancelConfirmPolicy: 'キャンセルポリシーを確認してください：',
      customerName: '予約名',
      actualPayment: '支払額',
      refundAmount: '払い戻し金額',
      orderId: '予約ID',
      orderCompletionTime: '予約時間',
      digitalTicketValidPeriod: 'QRコードは当日のみ有効です',
      digitalTicketWaiting: '*注文確認後、電子チケットがここに表示されます',
      sending: '送信中...',
      sendToEmail: 'メールで再送信',
      cancelConfirm: '注文をキャンセルします。よろしいですか？',
      cancelFee: 'キャンセル料金',
      cancelRemarkSelect: 'キャンセル理由を選択してください',
      inclusion: '含まれるもの',
      checklist: '注意事項',
      restrictions: '参加制限',
      requirements: '参加前・参加時必要事項',
      attireItems: '参加時必要な服装・持ち物',
      otherInfo: '備考・その他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'イメージ'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: 'その他',
      CANCEL_REASON_MODIFY_BOOKING: '予約内容を変更したいため',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '誤って予約したため',
      CANCEL_REASON_DUPLICATE_BOOKING: '重複して予約してしまったため',
      CANCEL_REASON_HEALTH_CONDITION: '体調不良のため',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '交通機関の遅延・運休のため',
      CANCEL_REASON_SCHEDULE_CONFLICT: '都合が合わなくなったため',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '他施設に変更するため'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    components: {
      selectOption: {
        title: 'オプション',
        quantity: '数量：{{quantity}}',
        addCart: 'カートに入れる',
        timeSelect: '時間を選択',
        quantitySelect: '数量を選択',
        quantitySelectLabel: '数量',
        soldOut: '売り切れ',
        total: '合計'
      },
      planCard: {
        tip: '当日券販売予定'
      },
      planDetailDialog: {
        title: 'プラン詳細',
        planContent: 'プラン内容',
        meetingPlace: '集合場所',
        cancellationPolicy: 'キャンセルポリシー'
      },
      priceTableDialog: {
        notes: {
          agePolicy: `※5歳以下は無料です。6歳で未就学の場合は無料、15歳で中学生の場合はこども料金、高校生の場合は大人料金を適用します。
※【障がい者・同伴者について】
 ・東京スカイツリー4Fチケットカウンターで入場券と引換えていただきます。その際、必ず障がい者手帳（コピー可）をご提示ください。ご提示いただけない場合は、通常料金との差額をお支払いいただきます。
 ・同伴者については、障がい者手帳をお持ちの方と同数まで障がい者料金が適用されます。その他の同伴者は通常料金となります。
 ・障がい者料金が適用される手帳の種類は「身体障がい者手帳 」、「療育手帳」 、「精神障がい者保健福祉手帳 」、「被爆者健康手帳」です。`
        }
      },
      payment: {
        ticket: 'チケット',
        option: 'オプション',
        total: '合計（税込）',
        details: '詳細',
        submit: '注文へ進む'
      },
      bookingInfo: {
        plan: 'プラン',
        dateTime: '日時',
        ticket: 'チケット',
        option: 'オプション',
        discount: '割引',
        total: '支払い金額（税込）'
      }
    },
    home: {
      title: '東京スカイツリー',
      header: {
        alt: '東京スカイツリー'
      },
      search: {
        placeholder: '商品を検索'
      },
      ticketList: {
        title: 'チケット一覧'
      },
      enjoyPack: {
        title: 'エンジョイパック'
      }
    },
    faq: {
      title: 'よくある質問',
      purchase: {
        title: 'チケット購入',
        q1: 'クレジットカードで決済できない場合はどうすればいいですか？',
        a1: `支払画面が最後まで進まない場合、以下をご確認ください。
1）通信状況
・一時的に通信状況が悪化し、決済が中断された可能性があります。
一度画面を閉じ、少し時間を置いてから、電波状況の良い環境で最初から決済をお試しください。

2）カードご利用状況・3Dセキュアに起因
 ご利用のクレジットカードの有効期限や利用限度額をご確認ください。
 また、ご利用の クレジットカード が「3Dセキュア」に対応しているかご確認ください。
※2025年4月より、オンライン購入ではクレジットカードの 「3Dセキュア」導入が義務化 されました。
東京スカイツリーの予約サイトでは、3Dセキュアが設定されたカードのみ決済が可能 です。

3）カード会社のセキュリティシステムの作動
 カードに問題がないにもかかわらず決済ができない場合、
 カード会社のセキュリティシステムが作動し、決済が中断された可能性があります。
 恐れ入りますが、一度 ご利用のカード会社へお問い合わせ ください。

・決済状況の詳細確認をご希望の場合は、下記のフォームよりお問い合わせください。
https://veltra.zendesk.com/hc/ja/requests/new?ticket_form_id=53455569113241`,
        q2: '希望日時がカレンダーで「×」になっているのはなぜですか？',
        a2: `＜東京スカイツリー展望台・展望回廊入場チケット＞
入場チケットは、ご利用日の 2か月前から販売を開始 いたします。
販売開始後、購入ページのカレンダーで ご希望の日付・時間帯がクリックできない場合は、すでに完売 となっております。
ご希望の日時が完売している場合は、前後の日時も併せてご検討ください。
▼ 購入ページはこちら
https://global-official-ticket.tokyo-skytree.jp/ja/home

※オンラインでのご購入は 当日まで可能 ですが、大型連休などは早期に完売 する場合がございます。
※オンライン購入チケットは、当日の窓口販売よりお得な価格 のため、事前購入をおすすめしております。
＜スカイツリーエンジョイパック＞
エンジョイパックは、ご利用日の 1か月前から販売を開始 いたします。
前日までご購入可能 です（当日の販売はございません）。`,
        q3: 'チケットの販売開始日はいつですか？',
        a3: `＜東京スカイツリー展望台・展望回廊入場チケット＞
・入場券は、ご利用日の 2か月前より順次販売を開始 いたします。
・オンラインでのご購入は 当日まで可能 ですが、大型連休などの繁忙期は、早期に完売となる場合がございます。

＜スカイツリーエンジョイパック＞
エンジョイパックは、ご利用日の 1か月前から販売を開始 いたします。
前日までご購入可能 です（当日の販売はございません）。

＜特別営業日のチケットについて＞
隅田川花火大会や元旦など、特別営業時間帯のチケットは、販売開始時期が通常と異なります。
詳細は、時期が近づきましたら 東京スカイツリー公式サイトにてお知らせいたします。`,
        q4: 'オンライン購入ではどのような支払い方法が利用できますか？',
        a4: `クレジットカード（VISA、Mastercard、American Express、JCB、Diners Club）、デビットカード、Alipay、WeChat Pay がご利用いただけます。`,
        q5: '当日券はありますか？現地で購入できますか？',
        a5: `＜東京スカイツリー展望台・展望回廊チケット＞
・当日券の専用枠はありません。
 すべてのチケットは事前販売としてご案内しており、事前の段階で在庫が残っている日時に限り、当日も購入できます。
 完売した日時のチケットは、当日の追加販売はありません。
・オンライン販売・現地販売機ともに、当日に在庫がある場合のみ購入可能 です。事前に完売した日時のチケットについて、当日の追加販売はございません。
・大型連休などの時期は、早期に完売となる場合 がございます。
・オンラインでの購入チケットは、当日の窓口販売よりお得な価格 となっているため、事前購入をおすすめしております。
・最新の販売状況は、以下の販売ページにてご確認ください。

▼販売ページはこちら
https://global-official-ticket.tokyo-skytree.jp/ja/home

＜スカイツリーエンジョイパック＞
・エンジョイパックは当日の販売はありません。ご利用希望日の前日までにご購入ください。`,
        q6: '中学卒業〜高校入学前の子どもはどのチケットを購入すればいいですか？',
        a6: `中学校の卒業式後〜高校入学前のお客様につきましては、入場日を基準に料金区分が変わります。
毎年 3 月 31 日までは 小人料金、4 月 1 日以降は 大人料金 が適用となります。`,
        q7: '会員登録は必須ですか？',
        a7: `東京スカイツリーのチケットをご購入いただくには、会員登録が必要です。

▼ ログインができない場合は、
FAQ内の「ログインできません。どうすればよいですか？」の項目にてご確認いただけます。`,
        q8: 'エンジョイパックに障がい者料金は適用されますか？',
        a8: `エンジョイパックは、すでに割引価格が適用されたお得なセット商品のため、追加で障がい者料金を適用することはできません。`,
        q9: '東京スカイツリーの施設内で、買い物や食事はできますか？また、駐車場は利用できますか？',
        a9: `スカイツリーの施設内情報、駐車場、団体予約、団体向け駐車場の詳細につきましては、
東京スカイツリー公式サイト内の「お問い合わせ」ページに掲載されている「よくある質問」をご確認ください。
▼東京スカイツリー公式サイト 施設・設備に関するご質問はこちらから
https://www.tokyo-skytree.jp/inquiry/faq.html

▼東京スカイツリー公式サイト 団体予約に関するページはこちら
https://www.tokyo-skytree.jp/ticket/group/general/`
      },
      late: {
        title: '入場時間に遅れそうな場合',
        q1: '予約している入場時間に遅れそうです。入場することはできますか？',
        a1: `原則として、ご購入時にご指定いただいた時間帯でのご入場をお願いしております。
しかしながら、ご事情により指定の時間に遅れる場合は、日時指定券をお持ちのお客様に限り、指定日当日に限って、案内中の列の最後尾よりご入場いただけます。
ご入場は順次ご案内となりますが、混雑状況により待ち時間が発生する場合がございます。
本日の営業時間は、東京スカイツリー公式サイトよりご確認ください。
▼営業時間カレンダー 
https://www.tokyo-skytree.jp/open-hours/`
      },
      conditions: {
        title: '眺望と混雑',
        q1: '当日の眺望（景色の見え方）は事前に確認できますか？',
        a1: `眺望は時間帯や気象状況により大きく変化するため、コールセンターにお電話いただいても、当日の眺望（見え方）についてご案内することはできません。
最新の天候につきましては、東京地域の気象情報をご確認ください。
また、雨天や曇天などによる視界不良の場合でも、ご返金や割引の対応は行っておりません。
キャンセルをご希望の場合は、マイページよりキャンセルポリシーおよびキャンセル料をご確認のうえ、お手続きをお願いいたします。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking`,
        q2: '当日の混雑状況を確認することはできますか？',
        a2: `・東京スカイツリー公式サイトのトップページに「混雑予想」を掲載しておりますので、ご参考ください。
・混雑状況により、エレベーターの待ち時間が発生する場合がございます。
なお、当日の待ち時間につきましては、コールセンターにお電話いただいてもご案内することができません。
お時間には余裕を持ってお越しください。
・展望台入場後の滞在時間に制限は設けておりませんが、当日の混雑状況やエレベーターの運行状況により、まれにスタッフが誘導を行う場合がございます。
▼東京スカイツリー公式サイト 混雑予想
https://www.tokyo-skytree.jp/ticket/congestion/`
      },
      email: {
        title: '予約完了メールが届かない',
        q1: '予約完了メールが届きません。どうすればよいですか？',
        a1: `予約時にご登録いただいたメールアドレス宛に、
「ご予約が確定しました（予約番号：ARS_SKYTREE-XXXX-XXXX）」という件名で自動メールをお送りしておりますので、ご確認ください。

・予約確定メールは 「@linktivity.co.jp」 のドメインから送信されます。
・迷惑メールフォルダ や ゴミ箱フォルダ に振り分けられている場合があります。
・普段あまり利用されないメールアドレスでご登録されている場合もございます。
・お心当たりのある別のメールアドレスもご確認ください。

メールが見当たらない場合は、マイページへログインし、予約状況のご確認をお願いします。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

＊東京スカイツリー公式サイト以外のオンライン旅行会社で購入された場合は、購入先の旅行会社へお問い合わせください。`
      },
      use: {
        title: 'チケットの利用・表示方法',
        q1: '決済が完了したのに、チケットが見当たりません。どうすればよいですか？',
        a1: `当日に必要となるチケットの URL 付きバウチャーは、マイページまたは予約確定メールよりご確認いただけます。

▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

▼予約確定メールは、以下の点をご確認ください。
・送信元ドメインは 「@linktivity.co.jp」 です。
・迷惑メールフォルダ や ゴミ箱フォルダ に振り分けられている場合があります。
・普段お使いにならないメールアドレスで登録されているケースもございます。
→ お心当たりのある別のメールアドレスの受信ボックスもご確認ください。

▼ログインができない場合は、
FAQ内の「ログインできません。どうすればよいですか？」の項目にてご確認いただけます。

＊東京スカイツリー公式サイト以外のオンライン旅行会社で購入された場合は、購入先の旅行会社へお問い合わせください。`,
        q2: 'QRコードがスマートフォンに表示されません。どうしたらよいですか？ *QRコードは株式会社デンソーウェーブの登録商標です。',
        a2: `当日に必要となるチケットの URL 付きバウチャーは、マイページ、または予約確定メールよりご確認いただけます。
モバイル端末で QR コードがうまく表示されない場合は、
一度画面を閉じていただき、電波状況の良い場所で再度表示をお試しください。
ご入場には QR コードが必要です。
事前に問題なく表示できるかご確認いただき、
スクリーンショットを保存しておくこともおすすめいたします。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

▼ログインができない場合は、
FAQ内の「ログインできません。どうすればよいですか？」の項目にてご確認いただけます。

＊東京スカイツリー公式サイト以外のオンライン旅行会社で購入された場合は、購入先の旅行会社へお問い合わせください。`,
        q3: 'ログインできません。どうすればよいですか？',
        a3: `1）まず、正しいメールアドレスでログインしているかをご確認ください。
普段あまりご利用にならないメールアドレスでご登録されている場合がございますので、お心当たりのある他のメールアドレスでもログインをお試しください。

2）新規会員登録時と同じログイン方法をご利用ください。
Gmailをご利用の場合は、新規登録の際に「Google」ボタンよりGoogle連携を選択して登録したか、「Eメール」ボタンより直接メールアドレスを入力して登録したかをご確認ください。
パスワードを忘れた場合は、ログイン画面の「パスワードをお忘れの場合」より、パスワードの再設定をお願いします。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

＊東京スカイツリー公式サイト以外のオンライン旅行会社で購入された場合は、購入先の旅行会社へお問い合わせください。`,
        q4: '予約完了メールを削除してしまいました。再送できますか？',
        a4: `以下のいずれかの方法でバウチャー・QRコードを表示いただけます。
1）マイページから予約内容を確認する方法

1マイページへログイン
2右上の 人型アイコン を選択
3「マイページ」→「予約情報」を選択
4予約一覧 を表示
5予約詳細画面 にてバウチャー（QRコード）を表示できます

▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

2）マイページからバウチャーを再送する方法

1マイページへログイン
2右上の 人型アイコン を選択
3「マイページ」→「予約情報」を選択
4予約一覧 を表示
5予約詳細画面内の 「バウチャーを送信」 ボタンから、
 ご希望のメールアドレス宛に チケットURL付きバウチャーを再送 できます
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking
＊東京スカイツリー公式サイト以外のオンライン旅行会社で購入された場合は、購入先の旅行会社へお問い合わせください。
*QRコードは株式会社デンソーウェーブの登録商標です。`,
        q5: 'アカウントを削除してしまい、マイページにログインできません。購入したチケットは利用できますか？',
        a5: `予約をキャンセルしていない限り、予約（チケット）は有効のままですので、そのままご利用いただけます。
チケットは、予約確定メール内に記載されている URL から、バウチャー（QR コード）を表示いただけます。

*QRコードは株式会社デンソーウェーブの登録商標です。`,
        q6: 'バウチャーを印刷して持参しても問題ありませんか？',
        a6: `QRコードは、紙にプリントアウトしたものもご利用いただけます。
また、スクリーンショットやモバイル端末の画面表示でもご利用いただけます。
印刷してお持ちいただく場合は、
QRコードが鮮明にプリントされているもの をご準備ください。

*QRコードは株式会社デンソーウェーブの登録商標です。`,
        q7: '展望台に入場したあと、滞在時間に制限はありますか？',
        a7: `展望台入場後の滞在時間に制限は設けておりません。`,
        q8: '事前にチケットを発券することはできますか？',
        a8: `2026年3月2日以降、チケットのリニューアルに伴い、現地での発券手続きは不要となります。
当日はバウチャー上のリンクをクリックし、画面上に表示されたQRコードを入場口にかざすことで直接ご入場いただけます。

*QRコードは株式会社デンソーウェーブの登録商標です。`,
        q9: '予約時間より早く到着した場合、早めに入場できますか？',
        a9: `ご予約の時間より前には入場できません。
ご購入時に指定いただいた時間帯でのご入場をお願いします。`,
        q10: '再入場はできますか？',
        a10: `一度展望台から退場後は、再入場はできません。`
      },
      changes: {
        title: '変更・キャンセル',
        q1: '入場日・入場時間・人数の変更はできますか？',
        a1: `申し訳ございませんが、指定された入場日・入場時間・人数の変更は承ることができません。
変更をご希望の場合は、一度現在のご予約をキャンセルのうえ、改めてご希望の内容でご購入ください。
・予約時間に遅れそうな場合について
ご事情により予約した時間に遅れる場合は、日時指定券をお持ちのお客様に限り、指定日当日に限って、ご案内中の列の最後尾よりご入場いただけます。順次ご案内となりますが、混雑状況により待ち時間が発生する場合がございます。

・キャンセルについて
キャンセルの際は、キャンセルポリシーに基づき規定のキャンセル料が発生いたします。
マイページよりキャンセルポリシーおよびキャンセル料をご確認のうえ、お手続きをお願いいたします。
なお、お電話やメールでのキャンセルは承っておりません。あらかじめご了承ください。

▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking`,

        q2: '天望デッキ入場券から、天望回廊とのセット券に変更できますか？',
        a2: `申し訳ございませんが、一度ご購入いただいた後に、天望回廊とのセット券へ変更することはできません。
天望回廊の入場チケットは、地上350ｍの天望デッキに設置されている券売機にて、当日ご購入いただけます。
ただし、天望回廊の混雑状況により、販売を中止する場合がございます。あらかじめご了承ください。`,
        q3: 'チケットはキャンセルできますか？',
        a3: `チケットの種類によってキャンセルポリシーが異なります。
キャンセルをご希望の場合は、マイページよりキャンセルポリシーおよびキャンセル料をご確認のうえ、お手続きをお願いいたします。
なお、キャンセル時には規定のキャンセル料が発生いたします。
また、誤操作防止のため、お電話やメールでのキャンセルは承っておりません。あらかじめご了承ください。

▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking`,

        q4: 'エンジョイパックに含まれている片方の施設を利用しなかった場合、返金はできますか？',
        a4: `お客様都合により、エンジョイパックに含まれる片方の施設をご利用されなかった場合でも、返金の対応はいたしかねます。`,
        q5: 'チケットの種類や日時を誤って購入してしまいました。どうすればよいですか？',
        a5: `・申し訳ございませんが、チケットの種類・日時・人数などを誤ってご購入された場合でも、変更を承ることはできません。恐れ入りますが、一度現在のご予約をキャンセルのうえ、改めてご希望の内容でご購入ください。
・キャンセルをご希望の場合は、マイページよりキャンセルポリシーおよびキャンセル料をご確認のうえ、お手続きをお願いいたします。
・キャンセルポリシーに基づき、規定のキャンセル料が発生いたします。
・誤操作防止のため、お電話やメールでのキャンセルは承っておりません。あらかじめご了承ください。

▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking`,

        q6: '災害・交通機関の運休／欠航・感染症などで訪問が難しい場合、キャンセルできますか？',
        a6: `臨時休館の場合を除き、特別なキャンセル対応は承っておりません。
臨時休館が発生した際は、東京スカイツリー公式サイトにてご案内いたします。
交通機関の計画運休などによりキャンセルをご希望の場合は、
マイページよりキャンセルポリシーおよびキャンセル料をご確認のうえ、ご自身でお手続きをお願いいたします。
なお、誤操作防止のため、お電話でのキャンセルは承っておりません。あらかじめご了承ください。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking
▼東京スカイツリー公式サイト
https://www.tokyo-skytree.jp/`,

        q7: '強風などによりエレベーターの運転が見合わせとなった場合、返金されますか？',
        a7: `お客様の安全を最優先し、上空の天候悪化や強風の影響により、展望台へのエレベーターが一時的に運転を見合わせる場合がございます。
最新の運行状況は、東京スカイツリー公式サイトにてご確認ください。
運転再開の見込みやご返金の可否につきましては、
現地スタッフが案内いたしますので、まずはスタッフへお声がけください。
▼東京スカイツリー公式サイト
https://www.tokyo-skytree.jp/`
      },
      payment: {
        title: 'お支払・各種割引',
        q1: 'カードが二重に引き落としされているようです。どうすればよいですか？',
        a1: `・まず、マイページにて予約状況をご確認ください。
予約が1件のみ表示されている場合、もう一方の決済は「利用速報」通知のみが届いており、実際の引き落としが行われていない可能性があります。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking
・決済状況をさらに詳しく確認したい場合は、下記のフォームよりお問い合わせください。
https://veltra.zendesk.com/hc/ja/requests/new?ticket_form_id=53455569113241`,
        q2: '決済が「失敗」と表示されました。どうしたらよいですか？',
        a2: `・まず、マイページにて予約が完了しているかご確認ください。
予約情報が表示されない場合、予約は完了しておりません。
以下の内容をご確認のうえ、改めてご購入手続きをお願いいたします。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

よく見られる原因：
1）通信状況による中断

一時的な通信環境の悪化や、同時間帯に多数の予約が集中した場合、ネットワークや決済が途中で中断されることがあります。
一度画面を閉じ、時間を置いて、電波状況の良い環境で 再度決済をお試しください。

2）カードの利用状況・3Dセキュア設定に起因
・ご利用のクレジットカードの 有効期限・利用限度額 に問題がないかご確認ください。
・カードが 「3Dセキュア（本人認証サービス）」に対応し、設定済み である必要があります。
2025年4月より、オンライン決済には「3Dセキュア」の導入が義務化されています。
そのため東京スカイツリーの予約サイトでは、3Dセキュア対応かつ設定済みのカードのみ ご利用いただけます。

3）カード会社のセキュリティシステムが作動した可能性
カード自体に問題がなくても、カード会社のセキュリティ判定により 不正利用防止機能が作動し、決済が中断される 場合があります。
時間を置いて 別のカードで再度お試しいただくか、ご利用のカード会社へお問い合わせ ください。

・決済状況について詳しい確認をご希望の場合は、下記のフォームよりお問い合わせください。
https://veltra.zendesk.com/hc/ja/requests/new?ticket_form_id=53455569113241`,
        q3: 'カード会社から利用通知が届いたのに、マイページに予約情報がなく、予約確定メールも届きません。どうすればよいですか？',
        a3: `下記のいずれかの状況が考えられます。

1)普段あまり利用しないメールアドレスで登録している場合
ご登録時に、普段使用しないメールアドレスを入力されている可能性があります。
お心当たりのある別のメールアドレスの受信ボックスおよび迷惑メールフォルダをご確認ください。
あわせて、マイページへのログイン もお試しください。
▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

2）Googleメールをご利用で、新規登録時と異なる方法でログインしている場合
予約（新規登録）時に選択したログイン方法と異なる方法でログインすると、マイページに予約情報が表示されません。
以下をご確認ください：

新規登録時に 「Emailログイン」 を選んだ場合
→ 「Emailログイン」 でログイン
新規登録時に 「Googleログイン」 を選んだ場合
→ 「Googleログイン」 でログイン


3)決済と予約が未完了となっている場合
カードの限度額確保の段階までは進んだものの、
一時的な通信環境の悪化等により、決済および予約が完了していない可能性があります。
カード会社の ご利用明細に記載があるか をご確認ください。

【決済・予約状況を詳しく確認したい場合】
決済状況について詳しい確認をご希望の場合は、下記のフォームよりお問い合わせください。
https://veltra.zendesk.com/hc/ja/requests/new?ticket_form_id=53455569113241`,
        q4: 'キャンセルをしました。返金はいつ行われますか？',
        a4: `チケットの種類によってキャンセル手数料が異なります。
まずはマイページにて、キャンセル手数料をご確認ください。

返金を受け取れるはずなのに反映されていない場合は、カード会社での返金処理に時間を要している可能性があります。
お手数ですが、一度カード会社へご確認をお願いいたします。

返金状況を詳しく確認したい場合
返金状況について、より詳しい確認をご希望の場合は、下記のフォームよりお問い合わせください。
https://veltra.zendesk.com/hc/ja/requests/new?ticket_form_id=53455569113241`,
        q5: '領収書を発行することはできますか？',
        a5: `・東京スカイツリー公式サイトでご購入の場合
領収書は、マイページ または 予約確定メール内の「領収書」ボタンより、ご自身で発行いただけます。
発行後は、「@linktivity.co.jp」ドメイン より
「領収書送付のご案内」という件名のメールが自動送信されます。
届かない場合は、迷惑メールフォルダやゴミ箱フォルダ もご確認ください。

▼マイページログインはこちらから
https://global-official-ticket.tokyo-skytree.jp/ja/booking

・団体予約の場合：
領収書の発行方法は、以下の専用ページをご確認ください。
▼東京スカイツリー公式サイト 団体予約に関するページはこちら
https://www.tokyo-skytree.jp/ticket/group/general/

・当日、現地でご購入の場合：
オンラインでの領収書発行はできません。
お手数ですが、以下よりお問い合わせください。
▼東京スカイツリー公式サイト
https://www.tokyo-skytree.jp/`
      },
      disabilities: {
        title: '障がい者料金の適用について',
        q1: '障がい者料金の適用について',
        a1: `適用条件について

障がい者手帳をお持ちの方と、その同伴者の方に障がい者料金を適用いたします。
同伴者のチケットは、手帳をお持ちの方と同じ人数分までご購入いただけます。
ご入場時に 障がい者手帳を確認 させていただきますので、当日はご提示をお願いいたします。


通常料金からの変更について
通常料金でチケットをご購入された場合、障がい者料金への変更はできません。
変更をご希望の場合は、
一度現在のご予約をキャンセルのうえ、改めてご希望の内容でご購入ください。

▼マイページログインはこちら
https://global-official-ticket.tokyo-skytree.jp/ja/booking`
      },
      group: {
        title: '団体予約について',
        q1: '団体予約について',
        a1: `団体予約は、東京スカイツリーの専用窓口にて承っております。
詳細は、東京スカイツリー公式サイトの「お問い合わせ」ページに掲載されている「お問い合わせ先一覧」をご確認ください。
▼東京スカイツリー公式サイト 団体予約専用窓口
https://www.tokyo-skytree.jp/inquiry/
`
      },
      tips: `LINKTIVITY（リンクティビティ）カスタマーサポート：<a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
オンライン購入に関するお問合せ電話番号：<a href="tel:03-6821-7195">03-6821-7195</a>
※お電話でお問い合わせいただいた場合、自動音声ガイダンスにてご案内します。その後、お問い合わせ内容に応じてオペレーターへお繋ぎします。
※お電話でのお問い合わせには、通話料が発生します。
オペレーター対応時間：10:00～19:00`
    }
  }
};
